import { render, staticRenderFns } from "./TokenOverview.vue?vue&type=template&id=c6b62ba0&scoped=true&"
import script from "./TokenOverview.vue?vue&type=script&lang=js&"
export * from "./TokenOverview.vue?vue&type=script&lang=js&"
import style0 from "./TokenOverview.vue?vue&type=style&index=0&id=c6b62ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b62ba0",
  null
  
)

export default component.exports